import React, {FC} from "react";
import styled from "styled-components";

interface IBlockTagsProps {
  tags: string[];
  title?: string;
  maxVisible?: number;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 16px;
  background-color: #22272b;
  overflow: hidden;
`;

const Title = styled.h4`
  color: #ffffff;
  opacity: 0.6;
  font-size: 16px;
  font-weight: 300;
  margin: 0;
  margin-bottom: 15px;
`;

const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background-color: rgba(250, 250, 250, 0.16);
  border-radius: 16px;
  color: rgba(255, 255, 255, 0.75);
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(113, 198, 250, 0.2);
    border-color: rgba(113, 198, 250, 0.5);
  }
`;

const ShowMoreButton = styled.button`
  background: none;
  border: none;
  color: #71c6fa;
  cursor: pointer;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 12px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(113, 198, 250, 0.1);
  }
`;

export const BlockTags: FC<IBlockTagsProps> = ({
  tags,
  title,
  maxVisible = 10,
}) => {
  const [showAll, setShowAll] = React.useState(false);

  if (!tags || tags.length === 0) {
    return null;
  }

  const visibleTags = showAll ? tags : tags.slice(0, maxVisible);
  const hasMore = tags.length > maxVisible;

  return (
    <div>
      {title && <Title>{title}</Title>}
      <TagsContainer>
        {visibleTags.map((tag, index) => (
          <Chip key={index}>
            {typeof tag === "string" ? tag : JSON.stringify(tag)}
          </Chip>
        ))}
        {hasMore && !showAll && (
          <ShowMoreButton onClick={() => setShowAll(true)}>
            +{tags.length - maxVisible} еще
          </ShowMoreButton>
        )}
        {showAll && hasMore && (
          <ShowMoreButton onClick={() => setShowAll(false)}>
            Скрыть
          </ShowMoreButton>
        )}
      </TagsContainer>
    </div>
  );
};
